export default __webpack_public_path__ + "static/media/empty.d8201537.png";